import { QueryClient } from '@tanstack/react-query';
import { GC, STALE } from './staleTimes';
import { queryRetryDelay, shouldRetryQuery } from './retryPolicy';
import { registerMutationDefaults } from '../mutations/registerMutationDefaults';

export function createAppQueryClient() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: STALE.feed,
        gcTime: GC.default,
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
        retry: shouldRetryQuery,
        retryDelay: queryRetryDelay,
      },
    },
  });

  // A festival's offline set must outlive the 24 h default. Per-query gcTime (festivalOffline.js, useFestivalMap,
  // useEventLineup) does not reach a query restored from the persisted cache: hydrate() builds it from these
  // defaults, so after a cold start the downloaded map / lineup got 24 h and was garbage-collected (and then left
  // out of the next persist) if the app stayed up that long. setQueryDefaults is what hydrate() does read.
  // Prefixes of queryKeys.festivalMap.published / .events.lineup (+ myArtistVotes under it) / .sets.index.
  queryClient.setQueryDefaults(['festival-map'], { gcTime: GC.festival });
  queryClient.setQueryDefaults(['events', 'lineup'], { gcTime: GC.festival });
  queryClient.setQueryDefaults(['sets'], { gcTime: GC.festival });

  registerMutationDefaults(queryClient);

  return queryClient;
}
